import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import CustomLoader from "../component/menu/CustomLoader";
import PrinterSettingsWrapper from "../component/settings/PrinterSettingsWrapper";
import { SettingOutlined } from "@ant-design/icons";

function PrinterSettings() {
  return (
    <div className="flex flex-col">
      <CustomLoader />
      <Header title={"Printer Settings"} />
      <div className="flex flex-col p-[24px] w-full mt-[80px] font-uregular">
        <div className="w-[500px] m-auto bg-white">
          <div className="p-5">
            <div className="w-full font-bold mb-10 ">
              <SettingOutlined style={{ fontSize: 16, marginRight: 10 }} />
              Printer Settings
            </div>
            <PrinterSettingsWrapper />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrinterSettings;
